import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, Platform } from '@ionic/angular';
import { Subject, Observable } from 'rxjs';
import { takeUntil, map, distinctUntilChanged, debounceTime, switchMap, startWith } from 'rxjs/operators';
import { CustomerModel } from 'src/app/models/customer-model';
import { AddressService } from 'src/app/services/address/address.service';
import { CommonAlertService } from 'src/app/services/alert/alert.service';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { flagChecker, isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { NAME_PATTERN, SCREENNAME_PATTERN, POboxValidator, POboxValidatorGroup, coutryPostalMatchValidator, birthdayValidator, noWhitespaceOnlyValidator, mustBeTruthy } from 'src/app/services/customFormValidators';
import { EventsService } from 'src/app/services/event/event.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService, eMfaStatuts } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';

@Component({
  selector: 'app-apply-boyd-rewards-step-two',
  templateUrl: './apply-boyd-rewards-step-two.component.html',
  styleUrls: ['./apply-boyd-rewards-step-two.component.scss'],
})
export class ApplyBoydRewardsStepTwoComponent implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() public pageParams: any
  @Input() kycFailProcess: boolean = false;
  @Input() kycCheckLastAttempt: boolean = false;


  @ViewChild("widgetsContent", { read: ElementRef })

  public widgetsContent: ElementRef<any>;

  public infoForm: FormGroup;
  public salutation: AbstractControl;
  public firstName: AbstractControl;
  public lastName: AbstractControl;
  public middleName: AbstractControl;
  public streetGroup: AbstractControl;
  public street: AbstractControl;
  public street2: AbstractControl;
  public city: AbstractControl;
  public autosearch: AbstractControl;
  public dateOfBirthGroup: AbstractControl;
  public dateOfBirthYear: AbstractControl;
  public dateOfBirthDay: AbstractControl;
  public dateOfBirthMonth: AbstractControl;
  public countryInfoGroup: AbstractControl;
  public country: AbstractControl;
  public postalCode: AbstractControl;
  public province: AbstractControl;
  public phoneNumber: AbstractControl;
  public securityQuestion: AbstractControl;
  public secondSecurityQuestion: AbstractControl;
  public securityAnswer: AbstractControl;
  public secondSecurityAnswer: AbstractControl;
  public ssn1: AbstractControl;
  public ssn2: AbstractControl;
  public ssn3: AbstractControl;
  public certOver18: AbstractControl;
  public ackRegulations: AbstractControl;
  public ackRegulationsEmail: AbstractControl;
  public ackRegulationsCasino: AbstractControl;
  public ackRegulationsOtherOption: AbstractControl;
  public allowPromoSms: AbstractControl;
  public allowPromoEmails: AbstractControl;
  public genderPrefix: any;

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public ackRegulationsCasinoName: string;
  public ackRegulationsName: string;
  public ackRegulationsOtherOptionName: string;
  public ackRegulationsPAOption: string;
  public addresses = [];
  public bonusCode: any;
  public buttonDisabled: boolean = false;
  public csrf_token: string;
  public customer: CustomerModel;
  public customerWillLogout: boolean = false;
  public environmentName: string;
  public error = null;
  public featureSiteTermsLink: string;
  public registrationSuccessful: boolean = false;
  public legalAge: number;
  public migrated: boolean = false;
  public offer: any;
  public promoCode: string;
  public provinces: any[];
  public refreshedCustomer: boolean = false;
  public responsibleGamingNumber: string;
  public selectedCountry: string;
  public selectedCountryCode: string;
  public showAddressResults = false;
  public showAddressFields = false;
  public secondSecurityQuestions: any[];
  public securityQuestions: any[];
  public welcomePackageImgUrl: string;

  public aliasNameCheck: boolean;
  public citizenshipCheck: boolean;
  public jobIndustryCheck: boolean;
  public employerNameCheck: boolean;
  public employerAddressCheck: boolean;
  public businessPhoneCheck: boolean;
  public displayRGLogo: boolean;
  public isSSNRequired: boolean;

  public aliasName: AbstractControl;
  public employerName: AbstractControl;
  public employerAddress: AbstractControl;
  public businessPhoneNumber: AbstractControl;
  public citizenshipGroup: AbstractControl;
  public citizenship: AbstractControl;
  public descriptiveOccupation: AbstractControl;
  public jobTitle: AbstractControl;
  public industry: AbstractControl;
  public ackRegulationsCan1: AbstractControl;
  public ackRegulationsCan2: AbstractControl;
  public ackRegulationsCan3: AbstractControl;
  public ackRegulationsCan4: AbstractControl;
  public ackRegulationsCan5: AbstractControl;
  public ackRegulationsCan6: AbstractControl;
  public ackRegulationsCan7: AbstractControl;

  public countries: any[];
  public citizenships: any[];
  public selectedCountryCitizenship: string;

  jobTitleList: any[];
  jobTitleListObservable: Observable<string[]>;
  holdJobTitleResponse: any[];
  public searchJob: string = '';
  public showJobTitleResults: boolean = false;

  jobIndustryList: any[];
  jobIndustryListObservable: Observable<string[]>;
  holdJobIndustryResponse: any[];
  public searchIndustry: string = '';
  public showJobIndustryResults = false;
  public stateProvinceLabel;
  public zipPostalCodeLabel;
  public isMfaEnabled: boolean = false;

  private countryList = this.configService.getConfig().FEATURE_COUNTRY_LIST || [];
  public selectedProvince: string = "";
  refreshed: boolean = false;
  cardResponse: string;

  public addressElProps = {
    inputStyle: 'none',
    label: 'or enter address manually',
    textAlign: 'left',
  };

  constructor(
    private addressService: AddressService,
    private appLinksService: AppLinksService,
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private events: EventsService,
    private globalErrorHandler: GlobalErrorHandlerService,
    private logoutService: LogoutService,
    private navigator: Navigator,
    private platform: Platform,
    private userSessionService: UserSessionService,
    private appStorageService: AppstorageTsService,
    private boydRewardsService: BoydRewardsService,
    private commonAlertService: CommonAlertService,
    private successMessageService: SuccessMessageService,

  ) {
  }

  ngOnInit(): void {
    //this.getAllCountries();
    this.selectedCountry = this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION ? this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION : 'USA';
    this.isMfaEnabled = flagChecker(this.configService.getConfig().FEATURE_MFA_ENABLED);

    if (this.selectedCountry === 'CANADA') {
      this.selectedCountryCode = 'CAN';
      this.stateProvinceLabel = 'Province';
      this.zipPostalCodeLabel = 'Postal Code';
    } else {
      this.selectedCountryCode = 'USA';
      this.stateProvinceLabel = 'State';
      this.zipPostalCodeLabel = 'Zip Code';
    }


    this.isSSNRequired = this.configService.getConfig().FEATURE_SIGNUP_SHOW_SSN_FIELD === '1' ? true : false;


    this.legalAge = this.configService.getConfig().FEATURE_LEGAL_AGE ?? 21;


    this.infoForm = new FormGroup({
      clientapp: new FormControl(''),
      csrf: new FormControl(),
      autosearch: new FormControl(''),
      firstName: new FormControl('', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      lastName: new FormControl('', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      middleName: new FormControl('', [Validators.pattern(NAME_PATTERN)]),
      aliasName: new FormControl(({ value: "", disabled: !this.aliasNameCheck }), [Validators.pattern(SCREENNAME_PATTERN)]),
      streetGroup: new FormGroup(
        {
          street: new FormControl('', [Validators.required, POboxValidator]),
          street2: new FormControl('', [POboxValidator]),
        }, POboxValidatorGroup
      ),
      city: new FormControl('', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      countryInfoGroup: new FormGroup(
        {
          country: new FormControl({ value: '', disabled: false }, [Validators.required]),
          postalCode: new FormControl('', [Validators.required]),
        },
        coutryPostalMatchValidator
      ),
      dateOfBirthGroup: new FormGroup(
        {
          dateOfBirthYear: new FormControl('', [Validators.required]),
          dateOfBirthDay: new FormControl('', [Validators.required]),
          dateOfBirthMonth: new FormControl('', [Validators.required]),
          hiddenLegalAge: new FormControl(this.legalAge)
        },
        birthdayValidator
      ),
      province: new FormControl('', [Validators.required]),
      phoneNumber: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(10), Validators.maxLength(10)]),
      customerAttributionData: new FormControl(''),
      extAffiliateId: new FormControl(''),
      ssn3: new FormControl(({ value: "", disabled: this.selectedCountryCode === 'CAN' }), [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(4), Validators.maxLength(4)]),

      certOver18: new FormControl(true, [mustBeTruthy]),
    });

    /* let formgroup = this.infoForm.get('countryInfoGroup');
     formgroup.get('country').patchValue(this.selectedCountryCode);
 
     this.getProvinces(this.selectedCountryCode);*/

    this.userSessionService.getCustomer().subscribe(customer => {
      if (customer) {
        this.customer = customer;
        if (this.customer != null) {
          this.promoCode = '';//this.customer.customData.find(data => data.key === 'promo_code').value;
        }
      }
    });

    this.infoForm.get('clientapp').setValue(this.configService.getClientApp());

    this.salutation = this.infoForm.get('salutation');
    this.firstName = this.infoForm.get('firstName');
    this.lastName = this.infoForm.get('lastName');
    this.middleName = this.infoForm.get('middleName');

    this.streetGroup = this.infoForm.get('streetGroup');
    this.street = this.streetGroup.get('street');
    this.street2 = this.streetGroup.get('street2');

    this.city = this.infoForm.get('city');
    this.autosearch = this.infoForm.get('autosearch');

    this.dateOfBirthGroup = this.infoForm.get('dateOfBirthGroup');
    this.dateOfBirthYear = this.dateOfBirthGroup.get('dateOfBirthYear');
    this.dateOfBirthDay = this.dateOfBirthGroup.get('dateOfBirthDay');
    this.dateOfBirthMonth = this.dateOfBirthGroup.get('dateOfBirthMonth');

    this.countryInfoGroup = this.infoForm.get('countryInfoGroup');
    this.country = this.countryInfoGroup.get('country');
    this.postalCode = this.countryInfoGroup.get('postalCode');

    this.province = this.infoForm.get('province');

    this.phoneNumber = this.infoForm.get('phoneNumber');

    this.certOver18 = this.infoForm.get('certOver18');

    if (this.isSSNRequired) this.ssn3 = this.infoForm.get('ssn3');


    if (this.kycFailProcess) this.addAdditionalKycControls();

    let googlePlaceDebounceTime = this.configService.getConfig().FEATURE_GOOGLE_PLACE_DEBOUNCE_TIME ?? 0;
    // watch the form changing the values on autosearch field
    this.infoForm.valueChanges.pipe(
      takeUntil(this.ngUnsubscribe),
      map(form => form['autosearch']),
      distinctUntilChanged(),
      debounceTime(~~googlePlaceDebounceTime),
      switchMap(value => {
        let selectedCountryVal = [];
        if (this.countries.filter) {
          selectedCountryVal = this.countries.filter(country => {
            return country.code == this.country.value
          });
        }
        return this.addressService.completeAddress(value, selectedCountryVal[0].code2);
      })
    ).subscribe(data => {
      if (data.payload) {
        this.addresses = data.payload;
        this.showAddressResults = true;
      }
    });

  }

  onInputAddress($event) {
    if ($event.target.value === '') {
      this.showAddressResults = false;
    }
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.authenticationService.getCsrfToken().subscribe(response => {
      if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
        this.csrf_token = response.payload.token;
        this.addressService.setCSRFToken(this.csrf_token);
      }
    });
    this.refreshedCustomer = false;
    this.getAllCountries();
    this.prePopulateFields();
  }

  public getAllCountries() {
    if (this.countryList.length) {
      this.countries = [];
      this.setCountryList(JSON.parse(this.countryList));
    } else {
      this.addressService.callGetAllCountries().subscribe((response: any) => {
        if (response && !!response.result) {
          this.setCountryList(response.payload);
        }
      }, error => {
        console.error(error);
        //this.error = this.handleError(error);
        // this.content.scrollToTop(10);
        this.scrollToTop();
      });
    }
  }

  private setCountryList(countryList) {
    const countriesList: any = countryList;
    for (let c in countriesList) {
      this.countries.push(countriesList[c]);
    }

    this.selectedCountry = this.onSelectCountry(countriesList);
    if (this.selectedCountry === 'CANADA') {
      let indexOfCanada = countriesList.findIndex(({ name }) => name === 'CANADA');
      let canadaObject = countriesList[indexOfCanada]
      if (this.countries[0].code !== canadaObject.code) this.countries.unshift(canadaObject)
      this.selectedCountryCode = 'CAN';
      this.stateProvinceLabel = 'Province';
      this.zipPostalCodeLabel = 'Postal Code';
    } else {
      this.selectedCountryCode = 'USA';
      this.stateProvinceLabel = 'State';
      this.zipPostalCodeLabel = 'Zip Code';
    }
    let formGroup = this.infoForm.get('countryInfoGroup');
    formGroup.get('country').patchValue(this.selectedCountryCode);
    this.updateCountryField();
    this.getProvinces();

  }

  public onChangeCountry(event) {
    this.getProvinces(event.target.value);
    if (event.target.value == 'USA') {
      this.infoForm.controls['ssn3'].enable()
    }
    else {
      this.infoForm.controls['ssn3'].disable();
    }
  }

  public onSelectCountry(countriesList: any): any {
    const country = this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION ? this.configService.getConfig().FEATURE_SITE_COUNTRY_REGION : 'USA';
    if (this.countries.length >= 1) return country;
    return this.customer.address.country;
  }

  public updateCountryField() {
    setTimeout(() => {
      this.refreshed = true;
    }, 500);
  }

  private addAdditionalKycControls(): any {
    this.infoForm.addControl('ssn1', new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(3), Validators.maxLength(3)]));
    this.infoForm.addControl('ssn2', new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(2), Validators.maxLength(3)]));
    this.ssn1 = this.infoForm.get('ssn1');
    this.ssn2 = this.infoForm.get('ssn2');
  }

  public getProvinces(country?: any) {

    let countryName = country ?? this.selectedCountry;
    if (countryName === 'CAN') {
      this.selectedCountryCode = 'CAN';
      this.stateProvinceLabel = 'Province';
      this.zipPostalCodeLabel = 'Postal Code';
    } else {
      this.selectedCountryCode = 'USA';
      this.stateProvinceLabel = 'State';
      this.zipPostalCodeLabel = 'Zip Code';
    }
    return new Promise((resolve, reject) => {
      this.addressService.callGetStatesByCountry(countryName === "CANADA" ? "CAN" : countryName).subscribe((response: any) => {
        if (response && !!response.result) {

          const provs = response.payload;
          this.provinces = [];
          for (let p in provs) {
            this.provinces.push({ code: p, name: provs[p] })
          }

          if (this.customer?.address?.state)
            this.selectedProvince = this.customer.address.state;
          return resolve(true);
        }
      }, (error) => {
        console.error(error);
        //this.error = this.handleError(error);
        this.content.scrollToTop(10);
        reject();
      });
    })
  }

  /*public getProvinces(country) {
    this.addressService.callGetStatesByCountry(this.selectedCountryCode).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          let provs = response.payload;
          this.provinces = [];
          for (let p in provs) {
            this.provinces.push({ code: p, name: provs[p] });
          }
        }
      },
      error => console.error('callGetStatesByCountry ', error)
    );
  }*/

  private prePopulateFields() {
    if (!this.securityQuestions || !this.secondSecurityQuestions) {
      this.addressService.callGetFormMetadata().subscribe(
        (response: any) => {
          if (response && response.result) {
            this.securityQuestions = response.payload.security_questions[1];
            this.secondSecurityQuestions = response.payload.security_questions[2];
          }
        }, error => console.error('callGetFormMetadata ', error)
      );
    }

    this.authenticationService.callGetAccount().subscribe(response => {
      if (response && !!response.result) {
        let customerInfo = response.payload.customer;
        let has_strong_auth = customerInfo.customData.filter(x => { return x.key === 'CONFIRM_AUTH'; });

        if (response.result == 1) {
          if (Object.keys(customerInfo.address).length == 0) {
            this.showAddressFields = false;
            this.showAddressResults = false;
            this.addressElProps.label = this.showAddressFields ? 'clear, back to auto search address' : 'or enter address manually';
            if (!this.showAddressFields) this.infoForm.controls['autosearch'].setValue('');
          } else if (Object.keys(customerInfo.address).length > 0 && customerInfo.address.constructor === Object) {
            this.showAddressFields = true;
            this.showAddressResults = true;
            this.addressElProps.label = this.showAddressFields ? 'clear, back to auto search address' : 'or enter address manually';
            if (!this.showAddressFields) this.infoForm.controls['autosearch'].setValue('');

            //birthdate format
            if (!!customerInfo.birthDate) {
              var birthDateFormattedArray = customerInfo.birthDate.split('-');
              var usersYear = Number(birthDateFormattedArray[0]);
              var usersMonth = Number(birthDateFormattedArray[1]);
              var usersDay = birthDateFormattedArray[2]; // don't make it a Number !!!
            }
            //security answers
            this.securityQuestion = customerInfo.securityQuestion;
            this.secondSecurityQuestion = customerInfo.secondSecurityQuestion;
          }

          let selectProvince = this.provinces.filter(item => {
            return item.code == customerInfo.address['state'];
          }).map(item => {
            return item.code;
          }).join('') || 'PA';

          this.infoForm.patchValue({
            salutation: customerInfo.salutation || 'Mr',
            firstName: customerInfo.firstName || '',
            lastName: customerInfo.lastName || '',
            middleName: customerInfo.middleName || '',
            aliasName: customerInfo.nickName || "",
            citizenshipGroup: {
              citizenship: customerInfo.citizenship || "",
            },
            descriptiveOccupation:
            {
              jobTitle: customerInfo.jobTitle || "",
              industry: customerInfo.jobIndustry || "",
            },
            phoneNumber: customerInfo.address['phoneNumber'] || '',
            securityQuestion: customerInfo.securityQuestion || '',
            securityAnswer: customerInfo.securityAnswer || '',
            secondSecurityQuestion: customerInfo.secondSecurityQuestion || '',
            secondSecurityAnswer: customerInfo.secondSecurityAnswer || '',
            city: customerInfo.address['city'] || '',
            province: selectProvince,
            allowPromoEmails: 'allowPromoEmails' in customerInfo ? customerInfo.allowPromoEmails : false,
            allowPromoSms: 'allowPromoSms' in customerInfo ? customerInfo.allowPromoSms : false,
            streetGroup: {
              street: customerInfo.address['street'] || '',
              street2: customerInfo.address['street2'] || '',
            },
            countryInfoGroup: {
              postalCode: customerInfo.address['postalCode'] || '',
            },
            dateOfBirthGroup: {
              dateOfBirthDay: customerInfo.birthDate ? usersDay : '',
              dateOfBirthMonth: customerInfo.birthDate ? usersMonth : '',
              dateOfBirthYear: customerInfo.birthDate ? usersYear : '',
            },
          });
        }
      }
    },
      error => {
        console.error(error);
      }
    );
  }

  get months() {

    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if (this.platform.is("capacitor")) {
      months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    }
    if (this.dateOfBirthYear.value == this.years[0]) {
      let extra = 11 - new Date().getMonth();
      for (extra; extra > 0; extra--) {
        months.pop();
        if (this.dateOfBirthMonth.value == months.length + 1) this.dateOfBirthMonth.setValue(months.length)
      }
    }
    return months;
  }

  get days() {
    let days = Array.apply(null, { length: 31 }).map(Number.call, Number)
    let displayDays = days.map(val => val + 1).map(val => (val < 10) ? "0" + val.toString() : val.toString());
    if (
      this.dateOfBirthYear.value == this.years[0] &&
      this.dateOfBirthMonth.value - 1 == this.months.indexOf(this.months[this.months.length - 1])
    ) {
      let extra = 31 - new Date().getDate();
      for (extra; extra > 0; extra--) {
        displayDays.pop();
        if (this.dateOfBirthDay.value == displayDays.length + 1) this.dateOfBirthDay.setValue(displayDays[displayDays.length - 1]);
      }
    }
    return displayDays;
  }

  get years() {
    let years = [];
    var min = new Date().getFullYear() - 100,
      max = new Date().getFullYear() - this.legalAge;
    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years;
  }

  hideSearchList() {
    this.showAddressResults = false;
  }

  // google places
  fillInAddress(result) {
    this.showAddressResults = false;
    this.toggleAddress();
    this.infoForm.controls['autosearch'].setValue(result.address);
    // get the address details and set the fields with data
    this.addressService.addressDetails(result.place_id, this.csrf_token).subscribe(response => {
      let place = response.payload;
      let street = '';
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (this.googleAddressTypes[addressType]) {
          var val = place.address_components[i][this.googleAddressTypes[addressType]];
          if (this.addressFieldsMap[addressType]) {
            let inputName = this.addressFieldsMap[addressType];
            // street = street_number + route
            if (inputName === 'street') {
              street = street + val + ' ';
              let streetGroup = <FormGroup>this.streetGroup;
              streetGroup.controls[inputName].setValue(street);
              // set postal code to countryInfoGroup
            } else if (inputName === 'postalCode') {
              let countryInfoGroup = <FormGroup>this.countryInfoGroup;
              countryInfoGroup.controls[inputName].setValue(val);
            } else {
              this.infoForm.controls[inputName].setValue(val);
            }
          }
        }
      }
    });
    return false;
  }

  toggleAddress() {
    this.showAddressFields = this.showAddressFields ? false : true;
    this.showAddressResults = this.showAddressFields ? true : false;
    this.addressElProps.label = this.showAddressFields ? 'clear, back to auto search address' : 'or enter address manually';
    if (!this.showAddressFields) {
      this.infoForm.controls['autosearch'].setValue('');
      this.street.setErrors({ incorrect: true });
      this.street2.setErrors({ incorrect: true });
      this.city.setErrors({ incorrect: true });
      this.province.setErrors({ incorrect: true });
      this.postalCode.setErrors({ incorrect: true });
    } else {
      this.street.setValue('');
      this.street2.setValue('');
      this.city.setValue('');
      this.province.setValue('');
      this.postalCode.setValue('');
    }
  }

  get googleAddressTypes() {
    return {
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name',
      administrative_area_level_1: 'short_name',
      country: 'long_name',
      postal_code: 'short_name',
    };
  }

  get addressFieldsMap() {
    return {
      street_number: 'street',
      route: 'street',
      locality: 'city',
      administrative_area_level_1: 'province',
      // country: 'country',
      postal_code: 'postalCode',
    };
  }

  onSubmit() {
    this.buttonDisabled = true;
    this.infoForm.addControl('street', new FormControl(this.streetGroup.get('street').value));
    this.infoForm.addControl('street2', new FormControl(this.streetGroup.get('street2').value));

    if (this.selectedCountryCode === 'USA') {
      let governmentIdValue = this.kycFailProcess ? this.ssn1.value + this.ssn2.value + this.ssn3.value : this.ssn3.value;
      this.infoForm.addControl('governmentId', new FormControl(governmentIdValue));
      this.infoForm.value.governmentId = governmentIdValue;
    }

    let formObj: any = this.infoForm.value;

    formObj.country = this.selectedCountryCode;

    this.authenticationService.callSignupStep2(formObj).subscribe(
      (response: any) => {
        this.buttonDisabled = false;
        if (response && !!response.result) {
          if (response.result == 1) {
            //To DO fix the logic
            let payloadObject = response.payload;
            this.userSessionService.refreshCustomer();

            if ((Object.keys(payloadObject).length > 0 && payloadObject.constructor === Object) && payloadObject.hasOwnProperty('is_verified')) {
              const isVerified: boolean = response.payload.is_verified;
              const kycStep: string = response.payload.kyc_step;
              const kyc_attempts: string = response.payload.kyc_attempts;
              const kycFailErrors: any = response.payload.kyc_fail_errors;
              const idScanResult: string = response.payload.id_scan_result;
              if (isVerified) {
                this.buttonDisabled = true;
                return this.activateCustomer();
              }

              //Social Logic
              //To DO : Clean up old code
              if (this.selectedCountryCode === 'CAN') return this.navigateToAccountCreated(undefined, true);
              let attempts = this.configService.getConfig().FEATURE_KYC_MAX_ATTEMPTS || 3;
              if (kyc_attempts < attempts) {
                return this.startKba(kycStep, kycFailErrors, kyc_attempts, idScanResult);
              }
              else if (kyc_attempts >= attempts) {
                return this.navigateToAccountCreated(undefined, true);
              } else {
                return this.startKba(kycStep, kycFailErrors, kyc_attempts, idScanResult);
              }
              //this.startKba(kycStep, kycFailErrors, kyc_attempts, idScanResult);
            }
          } else {
            this.registrationSuccessful = false;
            this.infoForm.removeControl('street');
            this.infoForm.removeControl('street2');
          }
        }
      },
      (error) => {
        this.buttonDisabled = false;
        this.authenticationService.getCsrfToken().subscribe(
          (response) => {
            if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
              this.csrf_token = response.payload.token;
            }

          }
        );
        this.globalErrorHandler.setErrorCode(error.getErrorCode().toUpperCase());
        switch (error.getErrorCode().toUpperCase()) {
          case 'AGE_VERIFICATION_FAILED':
            error.setErrorMessage('Form has errors, please see below');
            this.dateOfBirthGroup.setErrors({ 'AGE_VERIFICATION_FAILED': true })
            this.dateOfBirthGroup.markAsTouched();
            this.dateOfBirthGroup.markAsDirty();
            break;
          case 'ALREADY_HAS_ACCOUNT':
            error.setErrorMessage('It appears this account has already been created.');
            break;
          case 'CUSTOMER_IN_BLACKLIST':
            error.setErrorMessage('Cannot create account please contact customer support.');
            break;
          case 'GOVERNMENT_ID_ALREADY_EXISTS':
            error.setErrorMessage('Cannot create account please verify your data. Contact support if the issue continues.');
            break;
          case 'INVALID_BIRTHDATE':
            error.setErrorMessage('The birthdate entered is invalid');
            break;
          case 'BAD_CONTENT':
            error.setErrorMessage(error.getErrorMessage());
            break;
          case 'TOKEN_INVALID':
            error.setErrorMessage('Security checks discovered inconsistency with this form. Please try again.');
            break;
          case 'PHONE_ALREADY_EXISTS':
            error.setErrorMessage("Phone Number already exist and it's not available.");
            break;
          case 'IDNOW_RESPONSE_INVALID':
            error.SetErrorMessage("It appears this account has already been created. Please contact customer support.");
            break;
          default:
            error.setErrorMessage(error.getErrorMessage());
            break;

        }

        this.globalErrorHandler.setErrorMessage(error.getErrorMessage());
        this.error = error;
        // this.content.scrollToTop(10);
        this.scrollToTop();
        this.infoForm.removeControl('street');
        this.infoForm.removeControl('street2');
      }
    )
  }


  startKba(kycStep, kycFailErrors, kyc_attempts, idScanResult?) {
    if (kycStep && kycStep.toUpperCase() == 'PENDING_KBA') return this.navigator.navigateTo("IdologyKbaComponent");

    if (kycStep && kycStep.toUpperCase() == 'PENDING_RETRY') return this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: false, dontCallAppInitNext: true });
    if (kycStep && kycStep.toUpperCase() == 'PENDING_SOVOS') return this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: false, dontCallAppInitNext: true });
    if (kycStep && kycStep.toUpperCase() == 'PENDING_CS') return this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: false, dontCallAppInitNext: true });
    if (kycStep && kycStep.toUpperCase() == 'PENDING_IDSCAN' && idScanResult === 'pending') return this.navigateToAccountCreated(undefined, true);
    if (kycStep && kycStep.toUpperCase() == 'PENDING_IDSCAN' && idScanResult !== 'pending') return this.navigateToAccountCreated(undefined, true);
    return this.navigateToAccountCreated(undefined, true);
  }

  public doMFA(): any {
    this.activateCustomer();
  }

  onSetStrongAuth() {
    let confirmAuthObj = { "confirmAuth": 1 };
    this.authenticationService.callConfirmAuth(confirmAuthObj).subscribe(
      (response) => {
        if (response.result == 1) {
          this.userSessionService.refreshCustomer();
        }
      },
      (error) => {
        error.setErrorMessage('There was an issue trying to set strong authentication. Please contact customer support.');
        this.globalErrorHandler.setErrorMessage('There was an issue trying to set strong authentication. Please contact customer support.');
        this.error = error;
        this.content.scrollToTop(10);
      }
    );
  }

  unSetStrongAuth() {
    let confirmAuthObj = { "confirmAuth": 0 };
    this.authenticationService.callConfirmAuth(confirmAuthObj).subscribe(
      (response) => {
        if (response.result == 1) {
          this.userSessionService.refreshCustomer();
        }
      },
      (error) => {
        error.setErrorMessage('There was an issue trying to set strong authentication. Please contact customer support.');
        this.globalErrorHandler.setErrorMessage('There was an issue trying to set strong authentication. Please contact customer support.');
        this.error = error;
        this.content.scrollToTop(10);
      }
    );
  }

  activateCustomer = () => {
    const obj = {
      session_token: this.userSessionService.getSessionToken(),
      customer_id: this.customer.customerId,
    };
    this.boydRewardsService.callEnrollPlayerRewards(obj)
      .subscribe(
        res => {
          if (res && res.result) {
            //console.log(res.payload)
            this.cardResponse = res.payload;
            const jsonObject = JSON.parse(this.cardResponse);
            const payloadValue = jsonObject.payload;
            //console.log(payloadValue)
            this.appStorageService.setPlayerAsGuest(false);
            this.navigator.navigateTo("AccountCreatedConfirmationComponent", { customModalClass: 'crown-modal' }, { boydRewardApplySuccessFlag: true, cardNumber: payloadValue, userName: this.customer?.email })
          }
        },
        err => {
          this.buttonDisabled = false;
          switch (err.getErrorCode().toUpperCase()) {
            case 'CUSTOMER_NOT_FOUND':
              err.setErrorMessage('Sorry! Customer cannot be found');
              break;
            case 'CARD_ALREADY_EXISTS':
              err.setErrorMessage('Sorry! Reward Card already exists');
              break;
            case 'CONNECTION_ERROR':
              err.setErrorMessage('Sorry! There was a connection error');
              break;
            case 'CUSTOMER_PROFILE_MATCHED':
              // stay at this UI and let user input the reword card
              //this.customerProfileMatched = true;
              return;
            default:
              err.setErrorMessage('Oops! We cannot confirm your account information');
              break;
          }
          this.error = err;
        }
      );

  }


  closeModal = () => {
    this.navigator.dismissAll();
    this.logoutService.onLogout({ reason: 'CLOSE_SIGNUP_STEP2' });
  };

  openMatchedExternalLinks(code, title) {
    return this.appLinksService.openMatchedExternalLinksPopover(code, title)
  }

  getCitizenshipCountries() {
    this.addressService.callGetAllCountries().subscribe(
      (response: any) => {
        console.log("callGetAllCountries", response);
        if (response && !!response.result) {
          let countriesList = response.payload;

          // Also get countries
          this.countries = [];
          this.citizenships = [];
          console.log("check citizenships", this.citizenships);
          for (let c in countriesList) {
            if ('eligibSts' in countriesList[c]) {
              if (countriesList[c]['eligibSts'] == 'ELIGIBLE') {
                this.countries.push(countriesList[c]);
                // this.citizenships.push(countriesList[c]);
              }
            } else {
              this.countries.push(countriesList[c]);
              // this.citizenships.push(countriesList[c]);
            }

            // Push all countries for citizenship
            this.citizenships.push(countriesList[c]);
          }
          this.citizenships.sort(function (a, b) {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
          })
          let indexOfCanada = this.citizenships.findIndex(({ name }) => name === 'CANADA');
          let canadaElement = this.citizenships[indexOfCanada];
          this.citizenships.splice(indexOfCanada, 1);
          this.citizenships.splice(0, 0, canadaElement);


          if (this.countries.length == 1) {
            this.selectedCountry = this.countries[0].code;
            this.country.setValue(this.countries[0].code)
          }
          if (this.citizenships.length > 0) {
            this.selectedCountryCitizenship = this.citizenships[0].code2;
            this.citizenship.setValue(this.citizenships[0].code2)
          }
          this.getProvinces(this.selectedCountry);
        }
      },
      (error) => {
        console.log("callGetStatesByCountry ", error);
      }
    )
  }

  validateZipCode() {
    if (this.countryInfoGroup.get('country').value) {
      if (this.countryInfoGroup.hasError('mismatch')) {
        this.countryInfoGroup.get('postalCode').setErrors({ 'incorrect': true });
      }
    }
  }

  private navigateToAccountCreated(flag?: any, boydFlag?: boolean): any {
    if (flag) return this.navigator.navigateTo("AccountCreatedConfirmationComponent", { customModalClass: 'crown-modal' }, { emailAccountCreatedFlag: flag });
    if (flag === undefined && boydFlag) return this.navigator.navigateTo("AccountCreatedConfirmationComponent", { customModalClass: 'crown-modal' }, { boydRewardApplyFailFlag: boydFlag });
  }

  scrollToTop() {
    this.widgetsContent.nativeElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

}
